module.exports = __webpack_public_path__ + "svg/file_excel_no_arrow.0873a2e6ea3e803b71d8a16d9148b588.svg";